import { render, staticRenderFns } from "./DashboardCosts.vue?vue&type=template&id=3d6f333a&"
import script from "./DashboardCosts.vue?vue&type=script&lang=js&"
export * from "./DashboardCosts.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCosts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports